module.exports = __webpack_public_path__ + "img/NW11.8a4b7f8e.jpg";